<template>


    <div v-if="model" >
      <div class="list-notice">
        <figure class="image">
          <router-link class="anoticia" :to="{ name: 'public.noticia', params: {code: model.idnoticia } }">
            <img :src="obtenerUrl(model.imagen)" alt="Placeholder image" class="imgnoticia">
          </router-link>
        </figure>
      </div>


    </div>

</template>

<script>
  const endpointBase = __API__
    export default {
        props: ['model'],
        name: "SidebarItem",

      computed:{


      },
      data: function(){
        return {
          open: false,
          showChildren: false,
          rutaImg:'',
          endpointBase,
        }
      },
      components: {

      },
      methods:{
        obtenerUrl(idimg){
          return this.endpointBase+'images/imgs/'+idimg
        },
        toggleChildren() {
          this.showChildren = !this.showChildren;
          console.log(" show "+this.showChildren);
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TheNoticeItem.vue